import About from '../../components/content/About/About';

function AboutPage() {
    return (
        <About page={"about"} />
    );
}
export default AboutPage;